/* eslint-disable no-console */
import type { Middleware } from '../../ampli';

/**
 * Logging Middleware
 *
 * Logs all the things
 *
 * @param payload
 * @param next
 */
const loggerMiddleware: Middleware = (payload, next) => {
    const jsons = (o: unknown) => JSON.stringify(o, undefined, 2);

    const {
        event: { event_type, event_properties, plan, user_id, device_id }
    } = payload;

    const id = user_id ?? device_id;
    const propsJson = jsons(event_properties);
    const planJson = plan ? ` plan=${jsons(plan)}` : '';

    console.log(`%c[ANALYTICS_MOCK_AMPLI] id='${id}' event='${event_type}' properties=${propsJson}${planJson}`, `color: '#799cfb;`);

    next(payload);
};

export default loggerMiddleware;
